<template>
    <!--酒店报价列表-->
    <div class="hotel-quotation" v-if="quotationList">
        <div class="hotel-quotation-head">
            <div class="OrderHousing-title">我的报价</div>
            <div class="sort" v-if="$GFUN.isInArray([4],orderDetail.status)">
                <template v-for="item in match_hotel_list">
                    <div  :key="item.hotel_id" v-if="item.match_store_id==match_store_id" >
                        <span  class="mr-2">{{item.offer_status>0?'已报价':'待报价  '}}：{{item.hotel_title}}</span>
                        <el-button @click="$emit('quotationShow',{store_id:match_store_id})" type="primary" size="small"><i class="iconfont icon-ruzhu  mr-1"></i>{{item.offer_type==2?'重新报价':item.offer_type==1?'修改报价':'填写报价'}}</el-button>
                        <el-button v-if="item.offer_type!=2" @click="$emit('refuseShow',{store_id:match_store_id})" size="small"><i class="iconfont icon-yiquxiao1 mr-1"></i>接不了</el-button>
                    </div>
                </template>
            </div>
        </div>
        <!--报价标题-->
        <!-- <ul class="hotel-quotation-title">
            <li v-for="(item,index) in hotelQuotationTitle" :key="index" :style="{width:item.width}">
                {{item.title}}
            </li>
        </ul> -->
        <!--报价列表-->
        <template v-if="quotationList.count>0">
            <el-table
                class="hotel-quotation-list"
                :data="quotationList.list"
                :header-cell-style="{background:'#f2f7fe'}"
                border
                style="width: 100%">
                <el-table-column v-for="(item,index) in fundsForm" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center" >
                <!-- 自定义表头 -->
                    <template slot-scope="scope">
                            <!--酒店信息-->
                            <div  v-if="item.pattern==='title'">
                                <div class="hotel-title">
                                    <img v-lazy="$GFUN.formatImgSrc(scope.row['hotel_top_pic'],64,64)" class="hotel-img" @click="viewDetails(scope.row)"/>
                                    <div class="hotel-title-content">
                                        <div class="title">
                                            <p>
                                                {{ scope.row[item.prop]}}
                                                <img v-lazy="'/images/zfxj/icon_'+scope.row['hotel_state_star']+'.png'" :key="scope.row['hotel_state_star']" height="16px" v-if="scope.row['hotel_state_star']>0"/>
                                                <img v-lazy="'/images/xj/icon_'+scope.row['hotel_star']+'.png'" :key="scope.row['hotel_star']" height="16px" v-else/>
                                            </p>
                                        </div>
                                        <div class="address">
                                            <i class="iconfont icon-shijian mt-1"></i>
                                            <div class="offer-time"><p> 报价时间：</p>{{ scope.row['offer_time']| formatTimestamp(1)}}</div>
                                        </div> 
                                    </div>
                                </div>
                                <!-- <div class="offer-time"><p> 报价时间:</p>{{ scope.row['offer_time']| formatTimestamp(1)}}</div> -->
                            </div>
                            <!--报价人员信息-->
                            <div :class="{'text-center':item.center}" v-else-if="item.pattern==='mobile'">
                                <div class="hotel-mobile">
                                    <img :src="scope.row.offer_avatar?ImgPreUrl+scope.row.offer_avatar:'/images/avatar/avatar_0.png'" class="offer-img"/>
                                    <div class="hotel-name">
                                        <div>{{ scope.row['offer_name'] }}</div>
                                        <div class="phones" v-if="scope.row['position_name']">{{ scope.row['position_name'] }}</div>
                                        <!-- <div class="mobile">
                                            <i class="iconfont icon-shoujihao"></i>{{ scope.row['offer_mobile'] }}
                                        </div> -->
                                    </div>
                                    <!--@click.stop=" $_Tool.handleCopy(scope.row['offer_mobile'])"-->
                                    <el-tooltip class="item" effect="dark" :content="`手机号：${scope.row['offer_mobile']}`" placement="top">
                                        <div class="position_phone" >
                                            <i class="iconfont icon-shoujihao position_mobile"></i>
                                        </div>
                                    </el-tooltip>
                                </div>
                            </div>
                            <!--用房报价-->
                            <div   :class="{'text-center':item.center}" v-else-if="item.pattern==='room_offer_arr'">
                                <!--接不了状态-->
                                <template v-if="scope.row.meeting_offer_arr.length==0&&scope.row.room_offer_arr.length==0">
                                    <div class="canAnswer">
                                        酒店回复:接不了<br/>原因：{{ scope.row.offer_remark}}
                                    </div>
                                </template>
                                <!--报价状态-->
                                <template v-else>
                                    <div class="room_offer_arr">
                                        <!--用房报价-->
                                        <el-table
                                            :data="flatOfferTable(scope.row[item.prop])"
                                            border
                                            size="mini"
                                            :span-method="objectSpanMethod"
                                            style="width:100%"
                                            max-height="180"
                                            class="mb-2"
                                            :header-cell-style="{background:'#f5f7fa'}"
                                            v-if="scope.row.room_offer_arr.length>0"
                                        >
                                            <el-table-column label="时间"  align="center">
                                                <template slot-scope="scope">
                                                    {{scope.row.date| formatTimestamp(2)}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="名称"  align="center">
                                                <template slot-scope="scope">
                                                    <div  class="cursor-pointer" :class="scope.row.offer_id!=0&&'text-blue'" @click="showRoomImgs(scope.row.offer_id,'room')">
                                                        {{scope.row.offer_title}}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="价格"  align="center">
                                                <template slot-scope="scope">
                                                    {{scope.row.offer_price}}元/间
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="早餐"  align="center">
                                                <template slot-scope="scope">
                                                    {{scope.row.breakfast}}
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <!--会议室报价-->
                                        <div class="meeting" :class="{'text-center':item.center}" >
                                            <el-table
                                                :data="scope.row.meeting_offer_arr"
                                                border
                                                size="mini"
                                                style="width:100%"
                                                :header-cell-style="{background:'#f5f7fa'}"
                                                max-height="180"
                                                v-if="scope.row.meeting_offer_arr.length>0"
                                            >
                                                <el-table-column label="开会日期"  align="center">
                                                    <template slot-scope="scope">
                                                        {{scope.row.date| formatTimestamp(2)}}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="时段"  align="center">
                                                    <template slot-scope="scope">
                                                        {{ scope.row.timeslot| formatVar('TimeSlots')}}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="会议室"  align="center">
                                                    <template slot-scope="scope">
                                                        <div  class="cursor-pointer" :class="scope.row.offer_id!=0&&'text-blue'" @click="showRoomImgs(scope.row.offer_id,'meet')">
                                                        {{scope.row.offer_title}}
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="价格"  align="center">
                                                    <template slot-scope="scope">
                                                        {{scope.row.offer_price | formatMoney}}
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                    </div>
                                    <div class="remark-canAnswer" v-if="scope.row.offer_remark">
                                        报价说明：{{ scope.row.offer_remark}}
                                    </div>
                                </template>
                            </div>
                            <!--会议室报价-->
                            <!--其他-->
                            <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
                </template>
                </el-table-column>
                <el-table-column
                fixed="right"
                header-align="center"
                label="操作"
                width="100">
                <template slot-scope="scope">
                    <el-dropdown  @command="informUser($event,scope.row)">
                        <el-button type="primary" size="small"  style="margin: 0 auto; display: block;">查看<i class="ml-1 el-icon-arrow-down"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <template v-if="scope.row.meeting_offer_arr.length>0||scope.row.room_offer_arr.length>0">
                            <el-dropdown-item command="1">修改报价</el-dropdown-item>
                            <el-dropdown-item command="0">接不了</el-dropdown-item>
                            </template>

                            <template v-else>
                                <el-dropdown-item command="1">重新报价</el-dropdown-item>
                            </template>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
                </el-table-column>
            </el-table>
        </template>
        <!--暂无报价-->
        <template v-else>
            <div class="no-data">
                <img class="no-data-img" src="/images/order/icon_21.png" alt="">
                <div class="no-data-text">
                    <p class="titles">暂无报价信息！</p>
                    <p class="desc">{{$GFUN.isInArray([99],orderDetail.status)?'订单询价已结束':'请点击填写报价按钮'}}</p>
                </div>  
            </div>
        </template>
        <!-- <ul class="hotel-quotation-list">
            <li class="name w-40">
                <img src="https://cdn.dingdanyu.com/FXTLqZXTLqZ7iV0aWxytpzLolJl.jpg" alt=""/>
                <div>
                    <p>长春第一家酒店</p>
                    <p>三星/舒适</p>
                </div>
            </li>
            <li class="w-20">刘阳</li>
            <li class="w-20">15067116661</li>
            <li class="w-20">2026-06-03 10:34:32</li>
            <li class="w-40">2026-06-03 10:34:32</li>
            <li class="w-40">2026-06-03 10:34:32</li>
            <li class="w-20">成交</li>
        </ul> -->
    </div>
</template>

<script>
import { mapActions,mapState} from 'vuex'
export default {
  name: 'OrderQuotation',
  components: {},
  props: {
    //订单信息
    orderDetail: {
      type: Object,
      default: () => {}
    },
    //已报价列表
    quotationList: {
      type: Object,
      default: () => ({
        count:0,
        list:[]
      })
    },
    //未报价列表
    match_hotel_list: {
      type: Array,
      default: () => []
    },
    //当前订单酒店ID
    match_store_id: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
    options: [
        {
            value: '1',
            label: '全部报价'
            }, {
            value: '2',
            label: '只显示报价酒店'
            }, {
            value: '3',
            label: '价格由低到高'
            }, {
            value: '4',
            label: '价格由高到低'
        },
        ],
        value: '2',  
        //酒店报价列表
        fundsForm:[
          {name:'酒店名称',prop:'hotel_title',minWidth:250,pattern:'title'},
        //   {name:'联系人',prop:'offer_name',Width:80,center:true},
          {name:'销售',prop:'offer_mobile',minWidth:180,center:true,pattern:'mobile'},
        //   {name:'报价时间',prop:'offer_time',center:true,width:170,pattern:'time'},
          {name:'报价信息',prop:'room_offer_arr',center:true,minWidth:350,pattern:'room_offer_arr'},
        ],
        spanArr: [] // 纯数字数组，只给函数内部读取
    };
  },
  computed: {
        ...mapState(['RoomMeetDetail']),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
     ...mapActions(['getRoomDetail','getMeetDetail']),
    // 数组扁平化：日期拆分多条房型行
    flatOfferTable(list) {
        const res = []
        if (!Array.isArray(list)) return res
        list.forEach(item => {
            if (!Array.isArray(item.offer_info)) return
            item.offer_info.forEach(offer => {
            res.push({ date: item.date, ...offer })
            })
        })
        this.spanArr = this.computeDateSpan(res)
        return res
    },
    // 计算合并数组
    computeDateSpan(tableList) {
        const spanArr = []
        let pos = 0
        tableList.forEach((row, idx) => {
            if (idx === 0) {
            spanArr.push(1)
            pos = 0
            } else {
            if (row.date === tableList[idx - 1].date) {
                spanArr[pos] += 1
                spanArr.push(0)
            } else {
                spanArr.push(1)
                pos = idx
            }
            }
        })
        return spanArr
    },
    objectSpanMethod({ columnIndex, rowIndex }) {
      if (columnIndex === 0) {
        const r = this.spanArr[rowIndex]
        return {
          rowspan: r,
          colspan: r > 0 ? 1 : 0
        }
      }
      // 其他列不合并返回默认
      return { rowspan: 1, colspan: 1 }
    },
    //操作按钮
    informUser(command,item) {
        console.log(item);
        //0接不了,重新报价
        switch (command) {
          case '0':
            this.$emit('refuseShow',{store_id:item.offer_store_id});
            break;
          case '1':
            this.$emit('quotationShow',{store_id:item.offer_store_id})
            break;
        }
    },
    //展示房型、会议室图片
    async showRoomImgs(item,type) {
      if(item==0) return;
      let data = {
        type:3,
        id:item
      }
      switch (type) {
        case 'room':
          await this.getRoomDetail(data);
          break;
        case 'meet':
          await this.getMeetDetail(data);
          break;
      }
      if(this.RoomMeetDetail!=''){
        this._CarouselView({
          currentImg: 0,
          picArray: this.RoomMeetDetail.pic
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
    /******************酒店报价*******************/
    .OrderHousing-title{
        font-weight: bold;
        font-size: 16px;
    }
    .hotel-img{
        width: 80px;
        height: 80px;
        border-radius: 6px;
        cursor: pointer;
    }
    .offer-img{
        width: 60px;
        height: 60px;
        border-radius: 6px;
    }
    .hotel-quotation{
        width: 68%;
        padding: 16px 2%;
        background-color: #fff;
        border-radius: 6px;
    }
    .hotel-quotation-head{
        display: flex;
        line-height: 30px;
        p{
            margin-right: 10px;
        }   
    }
    .sort{
        display: flex;
        margin-left: auto;
        i{
            font-size: 14px;
        }
    }
    .hotel-map{
        margin-left: 10px;
        font-size: 12px;
        line-height: 30px;
        padding: 0 16px;
        border-radius: 4px;
        background-color: var(--smtc-color-primary);
        color: #fff;
        cursor: pointer;
    }
    .hotel-quotation-title{
        display: flex;
         background-color: #f2f7fe;
        margin-top: 18px;
        li{
            width: 50%;
            text-align: center;
                        border: 1px #eee solid;
            padding: 6px 10px;
           
        }
    }
    .hotel-quotation-list{
        margin-top: 20px;
    }
    .name{
        display: flex;
        img{
            width: 80px;
            height: 80px;
        }
    }
    .hotel-title{
        display: flex;
    }
    .hotel-title-content{
        margin-left: 10px;
        .title{

            font-weight: bold;  
            font-size: 16px;
            height: 46px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            
            p{
                align-items: center; /* 图片垂直居中 */
            }
        }
        .title img{
            margin-left: 3px;
            display: inline-block;
            vertical-align: middle; /* 垂直居中对齐文字 */
            margin-top: -3px; /* 与文字间距 */

        }
        .address{
            // width: 80px;
            text-align: left;
            margin-top: 4px;
            font-size: 12px;
            display: flex;
            i{
                font-size: 12px;
                margin-right: 4px;
                color: #999;
            }
        }
    }
    // .room_offer_arr{
    //     display: flex;
    // }
    // .meeting{
    //     margin-left: 10px;
    // }
    .canAnswer{
        text-align: center;
        width: 100%;
    }
    .no-data{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .no-data-img{
        width: 140px;
    }
    .no-data-text{
        display: flex;
        justify-content: center;
        flex-direction: column;
        .titles{
            font-weight: bold;
        }
        .desc{
            color: #999;
            margin-top: 6px;
        }
    }
    .offer-time{
        color: #999;
        font-size: 12px;
        display: flex;
        margin-top: 4px;
    }
    .hotel-mobile{
        display: flex;
        justify-content: center;
        width: 90%;
        margin: 0 auto;
        text-align:left;
    }
    .hotel-name{
        margin-left: 14px;
        height: 64px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .icon-shoujihao{
        font-size: 14px;
    }
    .phones{
        font-weight: normal;
        margin-top: 12px;
        background-color: #fdf0e4;
        font-size: 11px;
        margin-top: 4px;
        padding: 0px 6px;
        border-radius: 4px;
        color: #ab753e;
    }
    .position_phone{
        margin-left: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 10px;
        cursor: pointer;
    }
    .position_mobile{
        background-color: #edf5fe;
        width: 40px;
        height: 40px;
        border-radius: 50px;
        text-align: center;
        line-height: 40px;
        color:var(--smtc-color-primary);
        font-size: 16px;
    }
    .pagination{
        display: flex;
        justify-content: center;
    }
</style>
<style>
    .hotel-quotation .el-input,.hotel-quotation .el-input__inner{
        font-size: 12px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        width: 140px;
    }
    .hotel-quotation .el-input__icon{
        line-height: 30px;
    }
    .hotel-quotation .el-dropdown{
        display: block  ;
    }
</style>

